__turbopack_context__.v({
  "leftChub": "style-module-scss-module__2gGvRW__leftChub",
  "leftChubImage": "style-module-scss-module__2gGvRW__leftChubImage",
  "rightChub": "style-module-scss-module__2gGvRW__rightChub",
  "rightChubImage": "style-module-scss-module__2gGvRW__rightChubImage",
});
